import apiSlice from "./ApiSlice";

const BlogApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllBlogData: builder.query({
      providesTags: ["blog"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/blog",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteBlogById: builder.mutation({
      invalidatesTags: ["blog"],
      query: (id: any) => ({
        url: `/blog/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addBlog: builder.mutation({
      invalidatesTags: ["blog"],
      query: (body) => ({
        url: `/blog/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getBlogById: builder.query({
      providesTags: ["blog"],
      query: (id: string) => {
        return {
          url: `/blog/${id}`,
          method: "GET",
        };
      },
    }),

    //get Payment Modes
    getAllBlog: builder.query({
      providesTags: ["blog"],
      query: () => {
        return {
          url: `/blog`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateBlogById: builder.mutation({
      invalidatesTags: ["blog"],
      query: ({ body, id }) => ({
        url: `/blog/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusBlogById: builder.mutation({
      invalidatesTags: ["blog"],
      query: ({ body, id }) => ({
        url: `/blog/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllBlogDataQuery,
  useDeleteBlogByIdMutation,
  useAddBlogMutation,
  useGetBlogByIdQuery,
  useUpdateBlogByIdMutation,
  useGetAllBlogQuery,
  useChangeStatusBlogByIdMutation,
} = BlogApi;
